import React, { Fragment } from "react";
import Icon from "../../components/Icon/Icon";

// Helper function to format notification title with CSS classes instead of JSX
const formatNotificationTitle = (titleText) => {
    if (!titleText) return null;

    // Split by first space to separate name from rest of text
    const parts = titleText.split(' ');
    if (parts.length < 2) return titleText;

    const firstName = parts[0];
    const restOfMessage = parts.slice(1).join(' ');

    return (
        <>
            <span className="notifier-name">{firstName}</span> {restOfMessage}
        </>
    );
};

const NotificationItem = React.memo(({
    notification,
    typeProps,
    onNotificationClick
}) => {

    if (!typeProps) {
        return null;
    }

    const {
        icon,
        getTitle,
        getDescription,
        getEdition,
        uri,
        isImage,
        iconProps
    } = typeProps;

    const titleText = getTitle(notification);
    const title = formatNotificationTitle(titleText);
    const description = getDescription?.(notification);
    const edition = getEdition?.(notification);
    const redirectUri = uri(notification);
    const unreadClass = notification?.is_read ? "" : "unread"; // Apply unread class for visual distinction

    const handleClick = () => {
        onNotificationClick(redirectUri);
    };

    return (
        <div
            onClick={handleClick}
            className={`notification-row ${unreadClass}`}
        >
            <div className="notification-icon">
                {isImage ? <img src={icon} /> : <Icon
                    alias={icon}
                    color={iconProps?.color ? iconProps?.color : "#FF8CDC"}
                    stroke={iconProps?.stroke ? iconProps?.stroke : ""}
                    // {...iconProps ? iconProps : {}}
                />}
                
            </div>
            <div className="notification-content">
                <div className="notification-title">{title}</div>
                <div className="notification-description" title={edition ?
                    <Fragment>
                        {description}
                        <span className="dot mb-2"></span>
                        {edition}
                    </Fragment>
                    : description}>
                    {description}{edition ?
                        <Fragment>
                            <span className="dot mb-2"></span>
                            {edition}
                        </Fragment>
                        : ""}
                </div>
            </div>
        </div>
    );
});

NotificationItem.displayName = "NotificationItem";

export default NotificationItem;